import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { OktaAuth } from '@okta/okta-auth-js'
import { Toaster } from 'react-hot-toast'
import './index.css'
import { setOktaAuth } from './api/client'
import { OktaProvider, createOktaConfig } from '@vmlmap/shared-ui/auth'
import { RoleProvider } from './contexts/RoleContext'
import { RoleAwareRouter } from './components/RoleAwareRouter'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 3,
    },
  },
});

const oktaConfig = createOktaConfig({
  issuer: 'https://wpp.okta.com/oauth2/default',
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID || '',
  disableAuth: import.meta.env.VITE_DISABLE_AUTH === 'true',
});

let oktaAuth: OktaAuth | undefined;
if (!oktaConfig.disableAuth) {
  oktaAuth = new OktaAuth(oktaConfig);
  setOktaAuth(oktaAuth);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <OktaProvider config={oktaConfig} oktaAuth={oktaAuth}>
      <QueryClientProvider client={queryClient}>
        <RoleProvider>
          <RoleAwareRouter />
          <Toaster position="top-right" />
        </RoleProvider>
      </QueryClientProvider>
    </OktaProvider>
  </StrictMode>,
)
